import React, { memo, useContext } from 'react';
import T from '@prisjakt/ui-translate';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { AppContext } from '@prisjakt/ui-app-context';

import feedbackActions from '../../../feedback/actions';
import * as S from './styles';

const EmailSent = ({
  email,
  backTo,
  breadcrumbComponent,
  title,
  information,
  checkEmailNotice,
  feedbackToggle,
}) => {
  const { renderMode, market, t } = useContext(AppContext);

  return (
    <section>
      {renderMode !== 'native' && <S.Row>{breadcrumbComponent}</S.Row>}
      <S.EmailSent>
        <S.Columns>
          <S.Title>{title}</S.Title>
        </S.Columns>
        <S.Columns>
          {email && (
            <T domain="account" email={email}>
              email-sent.subtitle
            </T>
          )}
          <p>{information}</p>
        </S.Columns>
        <S.Notice>
          <S.NoticeIcon
            alt=""
            src={`${market.cdn}/rfe/g/email.dd63dcb273cc97d955e12639652c7f30.png`}
          />
          <div className="columns">{checkEmailNotice}</div>
        </S.Notice>

        <S.Columns>
          {t('account', 'email-sent.contact-support', {
            openFeedback: (
              <S.Link
                type="button"
                key="email-sent.contact-support"
                onClick={() => feedbackToggle()}
              >
                {t('account', 'contact-support.link')}
              </S.Link>
            ),
          })}
        </S.Columns>

        {backTo && backTo.name && (
          <S.Columns>
            <Link to={backTo.path}>
              <T domain="account" name={backTo.name}>
                email-sent.go-back-link
              </T>
            </Link>
          </S.Columns>
        )}
      </S.EmailSent>
    </section>
  );
};

const { func, string, shape, node } = PropTypes;

EmailSent.propTypes = {
  breadcrumbComponent: node.isRequired,
  title: string.isRequired,
  information: string.isRequired,
  checkEmailNotice: string.isRequired,
  email: string.isRequired,
  feedbackToggle: func.isRequired,
  backTo: shape({
    url: string,
    name: string,
  }),
};

EmailSent.defaultProps = {
  backTo: undefined,
};

export default connect(
  () => ({}),
  { feedbackToggle: feedbackActions.toggle }
)(memo(EmailSent));
